__turbopack_context__.v({
  "action": "SidebarOffers-module__SdvkCG__action",
  "activeOffer": "SidebarOffers-module__SdvkCG__activeOffer",
  "arrowActive": "SidebarOffers-module__SdvkCG__arrowActive",
  "arrowContainer": "SidebarOffers-module__SdvkCG__arrowContainer",
  "clickArea": "SidebarOffers-module__SdvkCG__clickArea",
  "collapsedIcon": "SidebarOffers-module__SdvkCG__collapsedIcon",
  "collapsedTrigger": "SidebarOffers-module__SdvkCG__collapsedTrigger",
  "collapsedWrapper": "SidebarOffers-module__SdvkCG__collapsedWrapper",
  "dropdown": "SidebarOffers-module__SdvkCG__dropdown",
  "dropdownItem": "SidebarOffers-module__SdvkCG__dropdownItem",
  "dropdownName": "SidebarOffers-module__SdvkCG__dropdownName",
  "dropdownSeparator": "SidebarOffers-module__SdvkCG__dropdownSeparator",
  "icon": "SidebarOffers-module__SdvkCG__icon",
  "name": "SidebarOffers-module__SdvkCG__name",
  "nameActive": "SidebarOffers-module__SdvkCG__nameActive",
  "offerList": "SidebarOffers-module__SdvkCG__offerList",
  "popover": "SidebarOffers-module__SdvkCG__popover",
  "popoverCollapsed": "SidebarOffers-module__SdvkCG__popoverCollapsed",
  "popoverContent": "SidebarOffers-module__SdvkCG__popoverContent",
  "trigger": "SidebarOffers-module__SdvkCG__trigger",
  "triggerOpen": "SidebarOffers-module__SdvkCG__triggerOpen",
  "wrapper": "SidebarOffers-module__SdvkCG__wrapper",
});
